/* Grondyke · Build a bundle · three-step builder.
   Reads its config (ladder tiers, labels, money format) from the section's JSON block, so the
   ladder is declared once in the section settings. Adds N line items via /cart/add.js; the
   automatic discounts in Shopify Admin apply at checkout. */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = (cents / 100);
    var m = (format || '${{amount}}').match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var out;
    function delim(num, precision, thousands, decimal) {
      var fixed = num.toFixed(precision);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }
    switch (key) {
      case 'amount_no_decimals': out = delim(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = delim(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = delim(value, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = delim(value, 2, "'", '.'); break;
      default: out = delim(value, 2, ',', '.');
    }
    /* money_format may be HTML; callers use textContent, so strip tags. */
    return String((format || '${{amount}}').replace(/\{\{\s*\w+\s*\}\}/, out)).replace(/<[^>]*>/g, '').trim();
  }

  function init(root) {
    var cfgEl = root.querySelector('[data-gk-bab-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var tiers = cfg.tiers.slice().sort(function (a, b) { return a.qty - b.qty; });
    var maxQty = tiers[tiers.length - 1].qty;
    var L = cfg.labels;

    var state = { step: 0, filter: 'all', picked: [] };
    var pools = Array.prototype.slice.call(root.querySelectorAll('[data-gk-pool]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-gk-step-tab]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-gk-filter]'));
    var hint = root.querySelector('[data-gk-hint]');
    var empty = root.querySelector('[data-gk-empty]');
    var emptyHead = root.querySelector('[data-gk-empty-head]');
    var emptyBody = root.querySelector('[data-gk-empty-body]');
    var list = root.querySelector('[data-gk-list]');
    var listEmpty = root.querySelector('[data-gk-list-empty]');
    var goal = root.querySelector('[data-gk-goal]');
    var fill = root.querySelector('[data-gk-fill]');
    var marks = Array.prototype.slice.call(root.querySelectorAll('[data-gk-mark]'));
    var totalLabel = root.querySelector('[data-gk-total-label]');
    var net = root.querySelector('[data-gk-net]');
    var gross = root.querySelector('[data-gk-gross]');
    var save = root.querySelector('[data-gk-save]');
    var back = root.querySelector('[data-gk-back]');
    var cta = root.querySelector('[data-gk-cta]');
    var prev = root.querySelector('[data-gk-prev]');
    var next = root.querySelector('[data-gk-next]');
    var errorEl = root.querySelector('[data-gk-error]');
    var busy = false;

    function tileData(tile) {
      return {
        id: tile.getAttribute('data-id'),
        title: tile.getAttribute('data-title'),
        note: tile.getAttribute('data-note'),
        price: parseInt(tile.getAttribute('data-price'), 10) || 0,
        image: tile.getAttribute('data-image')
      };
    }
    function qtyOf(id) { return state.picked.filter(function (p) { return p.id === id; }).length; }
    function tierFor(count) {
      var t = 0;
      tiers.forEach(function (x) { if (count >= x.qty) t = x.pct; });
      return t;
    }
    function nextTier(count) {
      for (var i = 0; i < tiers.length; i++) if (count < tiers[i].qty) return tiers[i];
      return tiers[tiers.length - 1];
    }
    function capitalize(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

    function renderPool() {
      var lastStep = state.step === pools.length - 1;
      pools.forEach(function (pool, i) {
        var active = i === state.step;
        pool.classList.toggle('is-hidden', !active);
        if (!active) return;
        var visible = 0;
        Array.prototype.forEach.call(pool.querySelectorAll('[data-gk-tile]'), function (tile) {
          var prof = tile.getAttribute('data-profile');
          var show = state.filter === 'all' || prof === state.filter || prof === 'all';
          tile.hidden = !show;
          if (show) visible++;
          var q = qtyOf(tile.getAttribute('data-id'));
          var qtyEl = tile.querySelector('[data-gk-qty]');
          if (qtyEl) { qtyEl.hidden = q < 2; qtyEl.textContent = q > 1 ? '×' + q : ''; }
          var add = tile.querySelector('[data-gk-add]');
          if (add) { add.textContent = q ? 'Added' : 'Add'; add.classList.toggle('is-added', q > 0); }
        });
        if (visible === 0) {
          var kind = (cfg.steps[i] && cfg.steps[i].kind) || '';
          var profName = state.filter === 'all' ? L.all : capitalize(state.filter);
          if (state.filter === 'bullitt') profName = 'Bullitt';
          emptyHead.textContent = L.emptyHead.replace('{profile}', profName).replace('{kind}', kind);
          emptyBody.textContent = state.filter === 'bullitt' ? L.emptyBullitt : L.emptyGeneric;
          empty.hidden = false;
          pool.classList.add('is-hidden');
        } else {
          empty.hidden = true;
        }
      });
      tabs.forEach(function (tab, i) {
        tab.classList.toggle('is-active', i === state.step);
        tab.setAttribute('aria-selected', i === state.step ? 'true' : 'false');
      });
      chips.forEach(function (chip) { chip.classList.toggle('is-active', chip.getAttribute('data-gk-filter') === state.filter); });
      if (hint) hint.textContent = (cfg.steps[state.step] && cfg.steps[state.step].hint) || '';
      if (prev) prev.disabled = state.step === 0;
      if (next) next.disabled = lastStep;
      if (back) back.disabled = state.step === 0;
    }

    function renderSummary() {
      var count = state.picked.length;
      var tier = tierFor(count);
      var grossCents = state.picked.reduce(function (n, p) { return n + p.price; }, 0);
      var netCents = Math.round(grossCents * (1 - tier / 100));
      var lastStep = state.step === pools.length - 1;

      list.innerHTML = '';
      state.picked.forEach(function (p, i) {
        var item = document.createElement('div');
        item.className = 'gk-item';
        item.innerHTML =
          '<div class="gk-item__thumb-wrap">' +
            (p.image ? '<img class="gk-item__thumb" src="' + p.image + '" alt="" loading="lazy" width="56" height="56">' : '<span class="gk-item__thumb"></span>') +
            '<button type="button" class="gk-item__remove" data-gk-remove="' + i + '" aria-label="' + L.remove + '">&#8722;</button>' +
          '</div>' +
          '<div class="gk-item__body">' +
            '<div class="gk-item__name"></div>' +
            '<div class="gk-item__note gk-mono"></div>' +
            '<div class="gk-item__price"></div>' +
          '</div>';
        item.querySelector('.gk-item__name').textContent = p.title;
        item.querySelector('.gk-item__note').textContent = p.note;
        item.querySelector('.gk-item__price').textContent = formatMoney(p.price, cfg.moneyFormat);
        list.appendChild(item);
      });
      listEmpty.hidden = count > 0;

      if (tier === tiers[tiers.length - 1].pct) {
        goal.textContent = L.goalDone.replace('{count}', count).replace('{pct}', tier);
      } else {
        var nt = nextTier(count);
        goal.textContent = L.goalNext.replace('{n}', nt.qty - count).replace('{pct}', nt.pct);
      }
      fill.style.width = Math.min(100, count / maxQty * 100) + '%';
      marks.forEach(function (m) { m.classList.toggle('is-hit', count >= parseInt(m.getAttribute('data-gk-mark'), 10)); });

      totalLabel.textContent = tier ? L.totalOff.replace('{pct}', tier) : L.total;
      net.textContent = formatMoney(netCents, cfg.moneyFormat);
      gross.hidden = !tier;
      gross.textContent = formatMoney(grossCents, cfg.moneyFormat);
      save.textContent = tier ? L.youSave.replace('{amount}', formatMoney(grossCents - netCents, cfg.moneyFormat)) : '';

      if (lastStep) {
        cta.textContent = count ? L.addN.replace('{count}', count + (count === 1 ? ' item' : ' items')) : L.add;
        cta.classList.toggle('is-muted', count === 0);
      } else {
        cta.textContent = L.next;
        cta.classList.remove('is-muted');
      }
    }

    function render() { renderPool(); renderSummary(); }

    function addToCart() {
      if (busy || !state.picked.length) return;
      busy = true;
      errorEl.hidden = true;
      var was = cta.textContent;
      cta.textContent = L.adding;
      var byId = {};
      state.picked.forEach(function (p) { byId[p.id] = (byId[p.id] || 0) + 1; });
      var items = Object.keys(byId).map(function (id) { return { id: parseInt(id, 10), quantity: byId[id] }; });
      var body = { items: items };
      var helper = window.Alpine && window.Alpine.store ? window.Alpine.store('xCartHelper') : null;
      if (helper && typeof helper.getSectionsToRender === 'function') {
        try { body.sections = helper.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) {}
      }
      fetch(cfg.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) throw new Error(res.json.description || res.json.message || 'error');
          var opened = false;
          try {
            if (helper && res.json.sections) helper.reRenderSections(res.json.sections);
            document.dispatchEvent(new CustomEvent('eurus:product:added', { detail: { product: res.json.items } }));
            var bubble = document.getElementById('cart-icon-bubble');
            if (helper && bubble) helper.currentItemCount = parseInt(bubble.innerHTML, 10) || 0;
            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
            var mini = window.Alpine.store('xMiniCart');
            if (mini && typeof mini.openCart === 'function') { mini.openCart(); opened = true; }
            document.dispatchEvent(new CustomEvent('eurus:cart:redirect'));
          } catch (e) { opened = false; }
          if (!opened) window.location.href = cfg.cartUrl;
          state.picked = [];
          render();
        })
        .catch(function () {
          errorEl.textContent = L.error;
          errorEl.hidden = false;
          cta.textContent = was;
        })
        .finally(function () { busy = false; });
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-gk-add], [data-gk-remove], [data-gk-step-tab], [data-gk-filter], [data-gk-prev], [data-gk-next], [data-gk-back], [data-gk-cta], [data-gk-empty-reset]');
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-gk-add')) {
        var tile = t.closest('[data-gk-tile]');
        if (tile) { state.picked.push(tileData(tile)); render(); }
      } else if (t.hasAttribute('data-gk-remove')) {
        state.picked.splice(parseInt(t.getAttribute('data-gk-remove'), 10), 1); render();
      } else if (t.hasAttribute('data-gk-step-tab')) {
        state.step = parseInt(t.getAttribute('data-gk-step-tab'), 10); render();
      } else if (t.hasAttribute('data-gk-filter')) {
        state.filter = t.getAttribute('data-gk-filter'); render();
      } else if (t.hasAttribute('data-gk-empty-reset')) {
        state.filter = 'all'; render();
      } else if (t.hasAttribute('data-gk-prev') || t.hasAttribute('data-gk-back')) {
        state.step = Math.max(0, state.step - 1); render();
      } else if (t.hasAttribute('data-gk-next')) {
        state.step = Math.min(pools.length - 1, state.step + 1); render();
      } else if (t.hasAttribute('data-gk-cta')) {
        if (state.step < pools.length - 1) { state.step++; render(); }
        else addToCart();
      }
    });

    render();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-gk-bab]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-gk-bab]') : null;
    if (root) init(root);
  });
})();
